/* Collection tools bar (snippets/fj-collection-tools.liquid, Jenny
   2026-10-08): Filter, Sort by and Show sold out under the title.

   - Sort by and Show sold out apply the moment they change.
   - Filter (Product Type = her sub-nav collections) is staged: ticking only
     updates the counts; See N Products applies, Reset clears the ticks.

   Counts come from one light request, ?view=fj-index
   (templates/collection.fj-index.liquid): every product on this page with
   the collections it belongs to. A type is offered only when it holds some
   but not all of the page's products, with its count beside it; when none
   qualifies the Filter button is left out.

   Shopify cannot filter a collection by other collections, so with types
   ticked the page shows every match at once (no page 2), in the page's own
   order with sold out last, built from the page's cards. The address keeps
   ?fj_type=a,b so refresh, Back and shared links rebuild it; the <head>
   hides the grid until then (snippets/fj-sold-out-default.liquid).

   Phones have one "Filter and Sort" button instead, opening a panel from
   the right with all three choices staged together until See N Products.
   That panel is moved to <body>, out of the bar's stacking context. */
(function () {
  if (customElements.get('fj-collection-tools')) return;

  var MANAGED = ['filter.v.availability', 'sort_by', 'page', 'section_id', 'fj_type', 'view'];

  function label(n) {
    if (n === 0) return 'No products';
    return 'See ' + n + (n === 1 ? ' Product' : ' Products');
  }

  function handleOf(card) {
    var link = card.querySelector('a[href*="/products/"]');
    var match = link && /\/products\/([^/?#]+)/.exec(link.getAttribute('href'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  class FjCollectionTools extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.filterTool = this.querySelector('[data-fj-tool="filter"]');
      this.sortTool = this.querySelector('[data-fj-tool="sort"]');
      this.form = this.querySelector('[data-fj-filter-form]');
      this.apply = this.querySelector('[data-fj-filter-apply]');
      this.soldOutBox = this.querySelector('[data-fj-sold-out]');
      this.cache = new Map();
      this.openTool = null;
      /* The search page has no Product Type filter and no type index
         (data-index="off"); counts come from the grid section instead. */
      this.noIndex = this.dataset.index === 'off';

      var params = new URLSearchParams(window.location.search);
      var types = (params.get('fj_type') || '').split(',').filter(Boolean);
      this.state = {
        sort: (this.querySelector('input[name="sort_by"]:checked') || {}).value || this.dataset.defaultSort,
        soldOut: this.soldOutBox ? this.soldOutBox.checked : true,
        types: types,
      };
      this.typeBoxes().forEach((box) => {
        box.checked = types.indexOf(box.value) !== -1;
      });

      this.drawer = this.querySelector('[data-fj-drawer]');
      if (this.drawer) {
        document.body.appendChild(this.drawer);
        this.drawerForm = this.drawer.querySelector('[data-fj-drawer-form]');
        this.drawerApply = this.drawer.querySelector('[data-fj-drawer-apply]');
        this.drawerPanel = this.drawer.querySelector('.fj-drawer__panel');
      }

      this.bind();
      this.bindDrawer();
      this.boot(types);
    }

    bind() {
      this.querySelectorAll('[data-fj-tool-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          var tool = button.closest('.fj-tool');
          if (this.openTool === tool) this.close(true);
          else this.open(tool);
        });
      });

      /* Click anywhere else, or Escape, closes the open panel. */
      document.addEventListener('pointerdown', (event) => {
        if (this.openTool && !this.openTool.contains(event.target)) this.close(false);
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.openTool) {
          event.preventDefault();
          this.close(true);
        }
      });
      /* Tabbing out closes it. A click on a row's words hands focus to the
         nearest focusable ANCESTOR (<main tabindex="-1">), which is not
         leaving, so ancestors do not count. */
      this.addEventListener('focusout', (event) => {
        var to = event.relatedTarget;
        if (!this.openTool || !to) return;
        if (this.openTool.contains(to) || to.contains(this.openTool)) return;
        this.close(false);
      });
      /* Only one dropdown on the page at a time (the shop-wide rule). */
      document.addEventListener('fj:dropdown-open', (event) => {
        if (this.openTool && event.detail !== this.openTool.querySelector('.fj-tool__panel')) this.close(false);
      });

      var done = this.querySelector('[data-fj-filter-done]');
      if (done) done.addEventListener('click', () => this.close(true));

      if (this.form) {
        this.form.addEventListener('change', () => this.staged());
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.update({ types: this.checkedTypes() });
          this.close(false, true);
        });
        this.form.querySelector('[data-fj-filter-reset]').addEventListener('click', () => {
          this.typeBoxes().forEach((box) => {
            box.checked = false;
          });
          this.staged();
        });
      }

      /* A pick with the mouse or a tap closes the list; arrow keys walk it
         and leave it open. */
      var pointerPick = false;
      this.sortTool.addEventListener('pointerdown', () => {
        pointerPick = true;
      });
      this.sortTool.addEventListener('change', (event) => {
        var radio = event.target;
        this.sortTool.querySelector('[data-fj-sort-label]').textContent = radio.dataset.label;
        this.update({ sort: radio.value });
        if (pointerPick) this.close(true);
        pointerPick = false;
      });
      this.sortTool.addEventListener('keydown', (event) => {
        pointerPick = false;
        if (event.key === 'Enter' && event.target.name === 'sort_by') {
          event.preventDefault();
          this.close(true);
        }
      });

      if (this.soldOutBox) {
        this.soldOutBox.addEventListener('change', () => this.update({ soldOut: this.soldOutBox.checked }));
      }

      window.addEventListener('popstate', () => {
        if (this.pushed) window.location.reload();
      });
    }

    /* ---------- State and addresses ---------- */

    typeBoxes() {
      return Array.from(this.querySelectorAll('input[name="fj_type"]'));
    }

    checkedTypes() {
      return this.typeBoxes()
        .filter((box) => box.checked)
        .map((box) => box.value);
    }

    /* The page address for a state. Anything else already in the address
       (a search term, say) is kept. */
    urlFor(state, extra) {
      var url = new URL(window.location.href);
      var params = url.searchParams;
      MANAGED.forEach((key) => params.delete(key));
      if (extra && extra.view) params.set('view', extra.view);
      /* Both values = every product. Saying so out loud keeps the
         sold-out-hidden default from sending the page back. */
      params.append('filter.v.availability', '1');
      if (state.soldOut) params.append('filter.v.availability', '0');
      if (state.sort && state.sort !== this.dataset.defaultSort) params.set('sort_by', state.sort);
      if (extra && extra.page > 1) params.set('page', extra.page);
      if (extra && extra.section) params.set('section_id', this.sectionId);
      if (!extra && state.types.length) params.set('fj_type', state.types.join(','));
      var query = params.toString();
      return url.pathname + (query ? '?' + query : '');
    }

    get(url, json) {
      if (!this.cache.has(url)) {
        this.cache.set(
          url,
          fetch(url)
            .then((response) => {
              if (!response.ok) throw new Error(response.status);
              return json ? response.json() : response.text();
            })
            .then((body) => (json ? body : new DOMParser().parseFromString(body, 'text/html')))
            .catch((error) => {
              this.cache.delete(url);
              throw error;
            })
        );
      }
      return this.cache.get(url);
    }

    /* Every product on the page (for a state's sort and sold-out choice),
       in order, with its collections. */
    index(state) {
      if (this.noIndex) return Promise.resolve(null);
      return this.get(this.urlFor(state, { view: 'fj-index' }), true);
    }

    /* How many products a state would show, read off its grid section. */
    countFor(state) {
      return this.grid(state, 1).then((doc) => {
        var grid = doc.getElementById('ProductGridContainer');
        return grid ? Number(grid.getAttribute('data-fj-count')) : NaN;
      });
    }

    grid(state, page) {
      return this.get(this.urlFor(state, { section: true, page: page }), false);
    }

    matches(products, types) {
      if (!types.length) return products;
      return products.filter((product) => product.c.some((handle) => types.indexOf(handle) !== -1));
    }

    /* ---------- Counts ---------- */

    /* Show the types that narrow this page, each with its count. With none,
       the panel says "Nothing to filter." instead of the button vanishing
       (Jenny: better cues than hiding a function). */
    showCounts(data) {
      if (!data || !this.filterTool || !this.form) return;
      var total = data.products.length;
      var shown = 0;
      this.typeBoxes().forEach((box) => {
        var n = this.matches(data.products, [box.value]).length;
        var row = box.closest('[data-fj-type]');
        var useful = (n > 0 && n < total) || box.checked;
        row.hidden = !useful;
        if (useful) shown++;
        var count = row.querySelector('[data-fj-count-for]');
        if (count) count.textContent = '(' + n + ')';
      });
      this.form.hidden = shown === 0;
      var empty = this.filterTool.querySelector('[data-fj-filter-empty]');
      if (empty) empty.hidden = shown > 0;
      this.indexData = data;
    }

    /* While ticking: the button's "(N)" and the See count follow along. */
    staged() {
      var types = this.checkedTypes();
      this.showPicked(types.length);
      if (!this.indexData || !this.apply) return;
      var n = this.matches(this.indexData.products, types).length;
      this.apply.textContent = label(n);
      this.apply.disabled = n === 0;
    }

    showPicked(n) {
      var picked = this.querySelector('[data-fj-picked]');
      if (picked) picked.textContent = n ? '(' + n + ')' : '';
    }

    /* ---------- Applying ---------- */

    boot(types) {
      var reveal = () => document.documentElement.classList.remove('fj-mixing');
      this.showPicked(types.length);
      this.showApplied();
      var indexing = this.index(this.state).then((data) => {
        this.showCounts(data);
        this.staged();
        return data;
      });
      if (!types.length) {
        reveal();
        indexing.catch(() => {});
        return;
      }
      this.render(this.state)
        .catch(() => {})
        .finally(reveal);
    }

    update(change) {
      var next = Object.assign({}, this.state, change);
      var html = document.documentElement;
      html.classList.add('fj-tools-busy');
      this.classList.add('is-counting');
      this.render(next)
        .then(() => {
          this.state = next;
          this.showApplied();
          this.syncDesktop();
          history.pushState({ fjTools: true }, '', this.urlFor(next));
          this.pushed = true;
          return this.index(next).then((data) => {
            this.showCounts(data);
            this.staged();
          });
        })
        .catch(() => {
          window.location.href = this.urlFor(next);
        })
        .finally(() => {
          html.classList.remove('fj-tools-busy');
          this.classList.remove('is-counting');
        });
    }

    render(state) {
      return state.types.length ? this.renderMatches(state) : this.renderPage(state);
    }

    /* No types ticked: the page's own first page, paginated as usual. */
    renderPage(state) {
      return this.grid(state, 1).then((doc) => this.swap(doc.getElementById('ProductGridContainer')));
    }

    /* Types ticked: every match on one page, in the page's order for the
       chosen sort, sold out last across the whole set. */
    renderMatches(state) {
      return this.index(state).then((data) => {
        var wanted = this.matches(data.products, state.types);
        var ordered = wanted.filter((p) => p.a).concat(wanted.filter((p) => !p.a));
        var pages = Math.max(1, Math.ceil(data.products.length / 24));
        var loads = [];
        for (var page = 1; page <= pages; page++) loads.push(this.grid(state, page));
        return Promise.all(loads).then((docs) => {
          var cards = new Map();
          docs.forEach((doc) => {
            doc.querySelectorAll('#product-grid > li').forEach((card) => {
              var handle = handleOf(card);
              if (handle && !cards.has(handle)) cards.set(handle, card);
            });
          });
          /* Shopify may answer with fewer per page than 24; fetch on until
             every wanted card is in hand. */
          var missing = ordered.some((p) => !cards.has(p.h));
          var more = missing ? this.morePages(state, pages + 1, cards, ordered) : Promise.resolve();
          return more.then(() => {
            var fresh = docs[0].getElementById('ProductGridContainer');
            if (!fresh) throw new Error('no grid');
            var container = document.importNode(fresh, true);
            var list = container.querySelector('#product-grid');
            if (list && list.tagName === 'UL') {
              list.innerHTML = '';
              ordered.forEach((p) => {
                var card = cards.get(p.h);
                if (card) list.appendChild(document.importNode(card, true));
              });
            }
            var pager = container.querySelector('.pagination-wrapper');
            if (pager) pager.remove();
            container.setAttribute('data-fj-count', String(list ? list.children.length : 0));
            this.swap(container, true);
          });
        });
      });
    }

    morePages(state, page, cards, ordered) {
      if (page > 12) return Promise.resolve();
      return this.grid(state, page).then((doc) => {
        var found = doc.querySelectorAll('#product-grid > li');
        found.forEach((card) => {
          var handle = handleOf(card);
          if (handle && !cards.has(handle)) cards.set(handle, card);
        });
        if (!found.length || !ordered.some((p) => !cards.has(p.h))) return;
        return this.morePages(state, page + 1, cards, ordered);
      });
    }

    swap(fresh, imported) {
      var current = document.getElementById('ProductGridContainer');
      if (!fresh || !current) throw new Error('no grid');
      var next = imported ? fresh : document.importNode(fresh, true);
      current.replaceWith(next);
      this.showItems(Number(next.getAttribute('data-fj-count')));
    }

    /* "Filter and Sort (2)" on phones: the types applied right now. */
    showApplied() {
      var picked = this.querySelector('[data-fj-picked-all]');
      if (picked) picked.textContent = this.state.types.length ? '(' + this.state.types.length + ')' : '';
    }

    /* "46 Items": what the page is showing now. */
    showItems(n) {
      var items = this.querySelector('[data-fj-items]');
      if (items && !isNaN(n)) items.textContent = n === 1 ? '1 Item' : n + ' Items';
    }

    /* The desktop controls follow a change made in the phone panel (and
       the other way round), so turning the phone sideways never shows
       stale choices. */
    syncDesktop() {
      if (this.soldOutBox) this.soldOutBox.checked = this.state.soldOut;
      this.querySelectorAll('input[name="sort_by"]').forEach((radio) => {
        radio.checked = radio.value === this.state.sort;
        if (radio.checked) this.sortTool.querySelector('[data-fj-sort-label]').textContent = radio.dataset.label;
      });
      this.typeBoxes().forEach((box) => {
        box.checked = this.state.types.indexOf(box.value) !== -1;
      });
      this.showPicked(this.state.types.length);
    }

    /* ---------- The phone panel ---------- */

    bindDrawer() {
      if (!this.drawer) return;
      this.onDrawerKey = (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeDrawer();
        }
      };
      this.querySelector('[data-fj-drawer-open]').addEventListener('click', (event) => this.openDrawer(event.currentTarget));
      this.drawer.querySelectorAll('[data-fj-drawer-close]').forEach((el) => {
        el.addEventListener('click', () => this.closeDrawer());
      });
      this.drawerForm.addEventListener('change', () => this.refreshDrawer());
      this.drawerForm.addEventListener('submit', (event) => {
        event.preventDefault();
        var next = this.drawerState();
        this.closeDrawer();
        this.update(next);
      });
      this.drawerForm.addEventListener('click', (event) => {
        if (event.target.closest('[data-fj-drawer-reset]')) this.resetDrawer();
        var head = event.target.closest('.fj-filters__head');
        if (head) {
          event.preventDefault();
          this.toggleGroup(head.parentElement);
        }
      });
    }

    drawerState() {
      var data = new FormData(this.drawerForm);
      return {
        soldOut: !!data.get('d_sold_out'),
        sort: data.get('d_sort') || this.dataset.defaultSort,
        types: data.getAll('d_type'),
      };
    }

    /* Open on the page as it is. */
    fillDrawer(state) {
      var form = this.drawerForm;
      form.querySelector('[name="d_sold_out"]').checked = state.soldOut;
      form.querySelectorAll('[name="d_sort"]').forEach((radio) => {
        radio.checked = radio.value === state.sort;
      });
      form.querySelectorAll('[name="d_type"]').forEach((box) => {
        box.checked = state.types.indexOf(box.value) !== -1;
      });
    }

    resetDrawer() {
      this.fillDrawer({
        soldOut: this.dataset.defaultShowSoldOut === 'true',
        sort: this.dataset.defaultSort,
        types: [],
      });
      this.refreshDrawer();
    }

    /* Types and counts for the staged choices; the sold-out choice changes
       which products are on the page, so the index is asked again for it. */
    refreshDrawer() {
      var staged = this.drawerState();
      var picked = this.drawer.querySelector('[data-fj-drawer-picked]');
      if (picked) picked.textContent = staged.types.length ? '(' + staged.types.length + ')' : '';
      this.drawer.classList.add('is-counting');
      var ticket = (this.drawerTicket = (this.drawerTicket || 0) + 1);
      if (this.noIndex) {
        this.countFor(staged)
          .then((n) => {
            if (ticket !== this.drawerTicket || isNaN(n)) return;
            this.drawerApply.textContent = label(n);
            this.drawerApply.disabled = n === 0;
          })
          .catch(() => {})
          .finally(() => {
            if (ticket === this.drawerTicket) this.drawer.classList.remove('is-counting');
          });
        return;
      }
      this.index(staged)
        .then((data) => {
          if (ticket !== this.drawerTicket) return;
          var total = data.products.length;
          var shown = 0;
          this.drawerForm.querySelectorAll('[name="d_type"]').forEach((box) => {
            var n = this.matches(data.products, [box.value]).length;
            var row = box.closest('[data-fj-drawer-type]');
            var useful = (n > 0 && n < total) || box.checked;
            row.hidden = !useful;
            if (useful) shown++;
            row.querySelector('[data-fj-drawer-count-for]').textContent = '(' + n + ')';
          });
          var empty = this.drawer.querySelector('[data-fj-drawer-empty]');
          if (empty) empty.hidden = shown > 0;
          var n = this.matches(data.products, staged.types).length;
          this.drawerApply.textContent = label(n);
          this.drawerApply.disabled = n === 0;
        })
        .catch(() => {})
        .finally(() => {
          if (ticket === this.drawerTicket) this.drawer.classList.remove('is-counting');
        });
    }

    openDrawer(trigger) {
      if (this.drawerOpen) return;
      this.drawerOpen = true;
      this.drawerTrigger = trigger;
      clearTimeout(this.drawerTimer);
      trigger.setAttribute('aria-expanded', 'true');
      this.fillDrawer(this.state);
      this.refreshDrawer();
      this.drawerForm.scrollTop = 0;

      var gap = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = gap > 0 ? gap + 'px' : '';
      document.body.style.overflow = 'hidden';

      void this.drawer.offsetWidth;
      requestAnimationFrame(() => {
        this.drawer.classList.add('is-open', 'is-opening');
        if (typeof trapFocus === 'function') trapFocus(this.drawerPanel, this.drawerPanel);
        else this.drawerPanel.focus({ preventScroll: true });
        setTimeout(() => this.drawer.classList.remove('is-opening'), 700);
      });
      document.addEventListener('keydown', this.onDrawerKey);
    }

    closeDrawer() {
      if (!this.drawerOpen) return;
      this.drawerOpen = false;
      this.drawer.classList.remove('is-open', 'is-opening');
      document.removeEventListener('keydown', this.onDrawerKey);
      if (this.drawerTrigger) this.drawerTrigger.setAttribute('aria-expanded', 'false');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.drawerTrigger);
      else if (this.drawerTrigger) this.drawerTrigger.focus({ preventScroll: true });
      this.drawerTimer = setTimeout(() => {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }, 480);
    }

    /* Sort by / Product Type glide open and shut (the browser can only snap
       a <details>): an even curve timed by distance, rows rising in on open
       and fading on close, the caret on the same clock, and a mid-way tap
       turns it round from where it is. */
    toggleGroup(group) {
      var head = group.querySelector('.fj-filters__head');
      var caret = head.querySelector('.icon-caret');
      var rows = Array.from(group.querySelectorAll('.fj-filters__list > .fj-check:not([hidden])'));
      var opening = !group.open || group.classList.contains('is-closing');
      var from = group.offsetHeight;
      if (group.fjAnim) group.fjAnim.cancel();
      (group.fjRowAnims || []).forEach((anim) => anim.cancel());
      group.fjRowAnims = [];

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        group.classList.remove('is-closing');
        group.open = opening;
        return;
      }

      var to;
      if (opening) {
        group.classList.remove('is-closing');
        group.open = true;
        to = group.offsetHeight;
      } else {
        group.classList.add('is-closing');
        to = head.offsetHeight + parseFloat(getComputedStyle(group).paddingBottom);
      }

      var duration = Math.round(Math.min(560, Math.max(300, 240 + Math.abs(to - from) * 0.5)));
      if (!opening) duration = Math.round(duration * 0.7);
      var easing = 'cubic-bezier(0.45, 0, 0.25, 1)';
      if (caret) {
        caret.style.transitionDuration = duration + 'ms';
        caret.style.transitionTimingFunction = easing;
      }

      if (opening) {
        var step = Math.min(28, 240 / Math.max(rows.length, 1));
        group.fjRowAnims = rows.map((row, i) =>
          row.animate(
            [{ opacity: 0, transform: 'translateY(0.6rem)' }, { opacity: 1, transform: 'none' }],
            { duration: 360, delay: 40 + i * step, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' }
          )
        );
      } else {
        group.fjRowAnims = rows.map((row) =>
          row.animate([{ opacity: 1 }, { opacity: 0 }], {
            duration: Math.round(duration * 0.6),
            easing: 'ease-in',
            fill: 'forwards',
          })
        );
      }

      group.style.overflow = 'hidden';
      var anim = group.animate([{ height: from + 'px' }, { height: to + 'px' }], {
        duration: duration,
        easing: easing,
        fill: 'forwards',
      });
      group.fjAnim = anim;
      if (opening) this.followOpen(group, to, anim);
      anim.onfinish = () => {
        if (!opening) {
          group.open = false;
          group.classList.remove('is-closing');
          group.fjRowAnims.forEach((rowAnim) => rowAnim.cancel());
          group.fjRowAnims = [];
        }
        group.style.overflow = '';
        anim.cancel();
        group.fjAnim = null;
      };
    }

    /* Opening a group low in the phone panel (Product Type) used to unfold
       it out of sight under the buttons (Jenny 2026-10-16). The panel now
       scrolls with the unfolding, frame by frame, until the group's end
       clears the buttons, without pushing its own heading off the top. */
    followOpen(group, to, anim) {
      var body = group.closest('.fj-drawer__body');
      if (!body) return;
      var foot = body.querySelector('.fj-drawer__foot');
      var top = group.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop;
      var room = body.clientHeight - (foot ? foot.offsetHeight : 0);
      var target = Math.min(top + to - room, top - 8);
      var start = body.scrollTop;
      if (target <= start) return;
      var tick = () => {
        // A tap that turns it round (closing) stops the follow.
        if (group.classList.contains('is-closing') || !group.open) return;
        var max = body.scrollHeight - body.clientHeight;
        body.scrollTop = Math.max(start, Math.min(target, max));
        if (body.scrollTop >= target - 1) return;
        // One more frame after the unfold ends, so the last step lands.
        if (group.fjAnim !== anim) {
          if (tick.done) return;
          tick.done = true;
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }

    /* ---------- Opening and closing ---------- */

    open(tool) {
      if (this.openTool) this.close(false);
      this.openTool = tool;
      var button = tool.querySelector('[data-fj-tool-toggle]');
      var panel = tool.querySelector('.fj-tool__panel');
      button.setAttribute('aria-expanded', 'true');
      tool.classList.add('is-open');
      document.dispatchEvent(new CustomEvent('fj:dropdown-open', { detail: panel }));
      if (tool === this.filterTool) {
        this.appliedTypes = this.checkedTypes();
        this.staged();
      }
      var first =
        Array.from(panel.querySelectorAll('input:checked')).find((input) => !input.closest('[hidden]')) ||
        Array.from(panel.querySelectorAll('input, [data-fj-filter-done]')).find((el) => !el.closest('[hidden]'));
      if (first) requestAnimationFrame(() => first.focus({ preventScroll: true }));
    }

    /* Closing the Filter panel without See N Products puts the ticks back
       the way the page is. */
    close(returnFocus, applied) {
      var tool = this.openTool;
      if (!tool) return;
      this.openTool = null;
      tool.classList.remove('is-open');
      var button = tool.querySelector('[data-fj-tool-toggle]');
      button.setAttribute('aria-expanded', 'false');
      if (tool === this.filterTool && !applied) {
        var keep = this.state.types;
        this.typeBoxes().forEach((box) => {
          box.checked = keep.indexOf(box.value) !== -1;
        });
        this.staged();
      }
      if (returnFocus) button.focus({ preventScroll: true });
    }
  }

  customElements.define('fj-collection-tools', FjCollectionTools);
})();
